import { render, staticRenderFns } from "./ticker.vue?vue&type=template&id=f8289932&scoped=true&"
import script from "./ticker.vue?vue&type=script&lang=js&"
export * from "./ticker.vue?vue&type=script&lang=js&"
import style0 from "./ticker.vue?vue&type=style&index=0&id=f8289932&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8289932",
  null
  
)

export default component.exports